var map = {
	"./ai/2018": 2532,
	"./ai/2018.json": 2532,
	"./ai/2019": 5262,
	"./ai/2019.json": 5262,
	"./ai/2020": 2644,
	"./ai/2020.json": 2644,
	"./ai/2021": 854,
	"./ai/2021.json": 854,
	"./ai/2022": 8554,
	"./ai/2022.json": 8554,
	"./ai/2023": 1535,
	"./ai/2023.json": 1535,
	"./ai/2024": 6417,
	"./ai/2024.json": 6417,
	"./ai/2025": 3142,
	"./ai/2025.json": 3142,
	"./ai/blog": 5115,
	"./ai/blog.json": 5115,
	"./ai/categories": 4175,
	"./ai/categories.json": 4175,
	"./ai/follow": 8967,
	"./ai/follow.json": 8967,
	"./ai/images/Adam-Geitgey.jpg": 5107,
	"./ai/images/Alec-Radford.jpg": 8774,
	"./ai/images/JJ-Kardwell.jpg": 7003,
	"./ai/images/Joanna.jpg": 2095,
	"./ai/images/Nathan.jpg": 6108,
	"./ai/images/Soumith.jpg": 4645,
	"./ai/images/adam.png": 7868,
	"./ai/images/ai-logo.png": 460,
	"./ai/images/ai.gif": 1340,
	"./ai/images/alexjc.png": 5962,
	"./ai/images/cybercode.jpg": 6812,
	"./ai/images/elon.jpg": 4162,
	"./ai/images/fei-fei-li.jpg": 3104,
	"./ai/images/jana.jpg": 4507,
	"./ai/images/johnc.jpg": 2583,
	"./ai/images/juhani.jpg": 9928,
	"./ai/images/martin.jpg": 8725,
	"./ai/images/thumb_Nathan_Benaich.jpg": 2982,
	"./ai/years": 3948,
	"./ai/years.json": 3948,
	"./android/2017": 8333,
	"./android/2017.json": 8333,
	"./android/2018": 5391,
	"./android/2018.json": 5391,
	"./android/2019": 1297,
	"./android/2019.json": 1297,
	"./android/2020": 828,
	"./android/2020.json": 828,
	"./android/2021": 7845,
	"./android/2021.json": 7845,
	"./android/2022": 5278,
	"./android/2022.json": 5278,
	"./android/2023": 4748,
	"./android/2023.json": 4748,
	"./android/2024": 1286,
	"./android/2024.json": 1286,
	"./android/2025": 6106,
	"./android/2025.json": 6106,
	"./android/blog": 8946,
	"./android/blog.json": 8946,
	"./android/follow": 4263,
	"./android/follow.json": 4263,
	"./android/images/Amrit_Sanjeev.jpg": 9574,
	"./android/images/AndrejKarpathy.jpg": 9145,
	"./android/images/AndyRubin.jpg": 7452,
	"./android/images/ChrisBanes.jpg": 377,
	"./android/images/ChrisLacy.jpg": 8196,
	"./android/images/ClementDelangue.jpg": 6807,
	"./android/images/DannyPostma.jpg": 8344,
	"./android/images/DroidSmith.jpg": 612,
	"./android/images/GinaTrapani.png": 834,
	"./android/images/JackClark.jpg": 6304,
	"./android/images/JamesKendrick.jpg": 9267,
	"./android/images/JoaquimVerges.jpg": 9344,
	"./android/images/JuhaniLehtimaki.jpg": 1010,
	"./android/images/MatiasDuarte.jpg": 9414,
	"./android/images/NickButcher.jpg": 7780,
	"./android/images/RomainGuy.jpg": 9056,
	"./android/images/SamAltman.jpg": 3387,
	"./android/images/XavierDucrohet.jpg": 1001,
	"./android/images/android-logo.png": 2410,
	"./android/images/cyanogen.jpg": 9620,
	"./android/images/saschasegan.jpg": 4871,
	"./android/images/sundarpichai.jpg": 8863,
	"./android/years": 3652,
	"./android/years.json": 3652,
	"./arvr/2018": 9439,
	"./arvr/2018.json": 9439,
	"./arvr/2019": 3963,
	"./arvr/2019.json": 3963,
	"./arvr/2020": 4553,
	"./arvr/2020.json": 4553,
	"./arvr/2021": 141,
	"./arvr/2021.json": 141,
	"./arvr/2022": 3860,
	"./arvr/2022.json": 3860,
	"./arvr/2023": 9088,
	"./arvr/2023.json": 9088,
	"./arvr/2024": 694,
	"./arvr/2024.json": 694,
	"./arvr/2025": 90,
	"./arvr/2025.json": 90,
	"./arvr/blog": 1321,
	"./arvr/blog.json": 1321,
	"./arvr/follow": 5148,
	"./arvr/follow.json": 5148,
	"./arvr/images/AlexKipman.jpg": 8709,
	"./arvr/images/AlexSchwartz.jpg": 4852,
	"./arvr/images/ChrisMilk.jpg": 4285,
	"./arvr/images/ClayBavor.jpg": 2118,
	"./arvr/images/JensChristensen.jpg": 4984,
	"./arvr/images/JohnCarmack.jpeg": 852,
	"./arvr/images/KentBye.jpg": 8699,
	"./arvr/images/PalmerLuckey.jpeg": 6519,
	"./arvr/images/TonyParisi.jpg": 5620,
	"./arvr/images/VRFocus.jpg": 9758,
	"./arvr/images/arvr-logo.png": 4086,
	"./arvr/years": 5878,
	"./arvr/years.json": 5878,
	"./backend/2025": 7676,
	"./backend/2025.json": 7676,
	"./backend/blog": 1332,
	"./backend/blog.json": 1332,
	"./backend/follow": 9123,
	"./backend/follow.json": 9123,
	"./backend/images/KelseyHightower.png": 9148,
	"./backend/images/MartinKleppmann.jpg": 8776,
	"./backend/images/backend-logo.png": 4918,
	"./backend/years": 9479,
	"./backend/years.json": 9479,
	"./biotech/2017": 1015,
	"./biotech/2017.json": 1015,
	"./biotech/2018": 3684,
	"./biotech/2018.json": 3684,
	"./biotech/2019": 4712,
	"./biotech/2019.json": 4712,
	"./biotech/2020": 8294,
	"./biotech/2020.json": 8294,
	"./biotech/2021": 9722,
	"./biotech/2021.json": 9722,
	"./biotech/2022": 3019,
	"./biotech/2022.json": 3019,
	"./biotech/2023": 6274,
	"./biotech/2023.json": 6274,
	"./biotech/2024": 7678,
	"./biotech/2024.json": 7678,
	"./biotech/2025": 6794,
	"./biotech/2025.json": 6794,
	"./biotech/blog": 6192,
	"./biotech/blog.json": 6192,
	"./biotech/follow": 5084,
	"./biotech/follow.json": 5084,
	"./biotech/images/andy.png": 3016,
	"./biotech/images/biotech-logo.png": 2449,
	"./biotech/images/sally.jpg": 1583,
	"./biotech/years": 6895,
	"./biotech/years.json": 6895,
	"./blockchain/2017": 9096,
	"./blockchain/2017.json": 9096,
	"./blockchain/2018": 9806,
	"./blockchain/2018.json": 9806,
	"./blockchain/2019": 1594,
	"./blockchain/2019.json": 1594,
	"./blockchain/2020": 5818,
	"./blockchain/2020.json": 5818,
	"./blockchain/2021": 4253,
	"./blockchain/2021.json": 4253,
	"./blockchain/2022": 4195,
	"./blockchain/2022.json": 4195,
	"./blockchain/2023": 9874,
	"./blockchain/2023.json": 9874,
	"./blockchain/2024": 7622,
	"./blockchain/2024.json": 7622,
	"./blockchain/2025": 9444,
	"./blockchain/2025.json": 9444,
	"./blockchain/blog": 8359,
	"./blockchain/blog.json": 8359,
	"./blockchain/follow": 1027,
	"./blockchain/follow.json": 1027,
	"./blockchain/images/Andreas.jpg": 3238,
	"./blockchain/images/VitalikButerin.jpeg": 1544,
	"./blockchain/images/blockchain-logo.png": 4013,
	"./blockchain/images/corda.jpg": 1609,
	"./blockchain/images/david.jpg": 1730,
	"./blockchain/images/dtapscott.jpeg": 17,
	"./blockchain/images/ethereum.jpg": 6662,
	"./blockchain/images/preethi.jpg": 6398,
	"./blockchain/images/william.jpg": 4660,
	"./blockchain/years": 3656,
	"./blockchain/years.json": 3656,
	"./creativedesign/2023": 204,
	"./creativedesign/2023.json": 204,
	"./creativedesign/2024": 1963,
	"./creativedesign/2024.json": 1963,
	"./creativedesign/2025": 2910,
	"./creativedesign/2025.json": 2910,
	"./creativedesign/blog": 2286,
	"./creativedesign/blog.json": 2286,
	"./creativedesign/creativedesignblogs/2023": 5445,
	"./creativedesign/creativedesignblogs/2023.json": 5445,
	"./creativedesign/creativedesignblogs/2024": 4856,
	"./creativedesign/creativedesignblogs/2024.json": 4856,
	"./creativedesign/creativedesignblogs/2025": 5786,
	"./creativedesign/creativedesignblogs/2025.json": 5786,
	"./creativedesign/follow": 861,
	"./creativedesign/follow.json": 861,
	"./creativedesign/images/cdesign.png": 1028,
	"./creativedesign/images/david_airey.jpg": 4393,
	"./creativedesign/images/paula_scher.jpg": 4276,
	"./creativedesign/images/sagmeister_walsh.jpg": 3090,
	"./creativedesign/years": 3438,
	"./creativedesign/years.json": 3438,
	"./cybersecurity/2017": 1473,
	"./cybersecurity/2017.json": 1473,
	"./cybersecurity/2018": 7492,
	"./cybersecurity/2018.json": 7492,
	"./cybersecurity/2019": 2063,
	"./cybersecurity/2019.json": 2063,
	"./cybersecurity/2020": 8626,
	"./cybersecurity/2020.json": 8626,
	"./cybersecurity/2021": 4003,
	"./cybersecurity/2021.json": 4003,
	"./cybersecurity/2022": 6823,
	"./cybersecurity/2022.json": 6823,
	"./cybersecurity/2023": 4152,
	"./cybersecurity/2023.json": 4152,
	"./cybersecurity/2024": 5300,
	"./cybersecurity/2024.json": 5300,
	"./cybersecurity/2025": 1782,
	"./cybersecurity/2025.json": 1782,
	"./cybersecurity/blog": 5597,
	"./cybersecurity/blog.json": 5597,
	"./cybersecurity/follow": 3552,
	"./cybersecurity/follow.json": 3552,
	"./cybersecurity/images/bruce.jpeg": 2824,
	"./cybersecurity/images/catalin.jpeg": 8053,
	"./cybersecurity/images/christopher.jpg": 2062,
	"./cybersecurity/images/cybersec.png": 9626,
	"./cybersecurity/images/florian.jpeg": 4252,
	"./cybersecurity/images/keren.jpg": 595,
	"./cybersecurity/images/kimzetter.jpg": 1701,
	"./cybersecurity/images/lesley.jpg": 7222,
	"./cybersecurity/images/maddie.jpg": 1094,
	"./cybersecurity/images/mikko.jpg": 8497,
	"./cybersecurity/images/troy.jpeg": 3823,
	"./cybersecurity/years": 8594,
	"./cybersecurity/years.json": 8594,
	"./devops/2017": 5021,
	"./devops/2017.json": 5021,
	"./devops/2018": 7803,
	"./devops/2018.json": 7803,
	"./devops/2019": 78,
	"./devops/2019.json": 78,
	"./devops/2020": 8141,
	"./devops/2020.json": 8141,
	"./devops/2021": 3178,
	"./devops/2021.json": 3178,
	"./devops/2022": 1133,
	"./devops/2022.json": 1133,
	"./devops/2023": 7925,
	"./devops/2023.json": 7925,
	"./devops/2024": 9466,
	"./devops/2024.json": 9466,
	"./devops/2025": 4980,
	"./devops/2025.json": 4980,
	"./devops/blog": 1507,
	"./devops/blog.json": 1507,
	"./devops/follow": 1410,
	"./devops/follow.json": 1410,
	"./devops/images/AndrewClayShafer.jpg": 2567,
	"./devops/images/AndrewHay.jpg": 3746,
	"./devops/images/CourtneyNash.jpg": 1489,
	"./devops/images/DamonEdwards.jpg": 1836,
	"./devops/images/DominicaDeGrandis.jpg": 4278,
	"./devops/images/GeneKim.jpg": 7661,
	"./devops/images/GeorgeSpafford.jpg": 6753,
	"./devops/images/JezHumble.jpg": 7817,
	"./devops/images/JulianSimpson.jpg": 3537,
	"./devops/images/KevinBehr.jpg": 6095,
	"./devops/images/MarkR.Hinkle.jpg": 3064,
	"./devops/images/MartenMickos.jpg": 5196,
	"./devops/images/MartinFowler.jpg": 8601,
	"./devops/images/RedStateBlackSheep.jpg": 463,
	"./devops/images/Sascha.jpg": 8767,
	"./devops/images/StephenNelson-Smith.jpg": 1248,
	"./devops/images/XavierAmatriain.jpg": 8874,
	"./devops/images/adrianco.jpg": 5174,
	"./devops/images/allspaw.jpg": 2911,
	"./devops/images/estherderby.jpg": 756,
	"./devops/images/hullsean.jpg": 7773,
	"./devops/images/joemckendrick.jpg": 4524,
	"./devops/images/security-logo.png": 1632,
	"./devops/years": 5335,
	"./devops/years.json": 5335,
	"./embedded-system/2025": 8226,
	"./embedded-system/2025.json": 8226,
	"./embedded-system/blog": 7644,
	"./embedded-system/blog.json": 7644,
	"./embedded-system/follow": 3095,
	"./embedded-system/follow.json": 3095,
	"./embedded-system/images/Bhavesh.jpg": 145,
	"./embedded-system/images/Ian.jpg": 478,
	"./embedded-system/images/John.jpg": 4509,
	"./embedded-system/years": 6219,
	"./embedded-system/years.json": 6219,
	"./foss/2025": 4439,
	"./foss/2025.json": 4439,
	"./foss/blog": 4165,
	"./foss/blog.json": 4165,
	"./foss/follow": 5038,
	"./foss/follow.json": 5038,
	"./foss/images/Ansh-Arora.jpg": 6926,
	"./foss/images/Deb-Nicholson.jpg": 1498,
	"./foss/images/Deepu-S-Nath.jpg": 3451,
	"./foss/images/Greg-Kroah-Hartman.jpg": 9502,
	"./foss/images/Karen-Sandler.jpg": 4303,
	"./foss/images/Linus-Torvalds.jpg": 6151,
	"./foss/images/Mark-Shuttleworth.jpg": 6460,
	"./foss/images/Miguel-de-Icaza.jpg": 9535,
	"./foss/images/Moosa-Mehar.jpg": 8900,
	"./foss/images/Rahul-Poruri.jpg": 4025,
	"./foss/images/Richard-Stallman.jpg": 3500,
	"./foss/images/Rushabh-Mehta.jpg": 2716,
	"./foss/images/Satish-Babu.jpg": 947,
	"./foss/images/Sunil-TT.jpg": 2237,
	"./foss/images/Vishal-Arya.jpg": 2254,
	"./foss/years": 5825,
	"./foss/years.json": 5825,
	"./frontend/2017": 7535,
	"./frontend/2017.json": 7535,
	"./frontend/2018": 56,
	"./frontend/2018.json": 56,
	"./frontend/2019": 9743,
	"./frontend/2019.json": 9743,
	"./frontend/2020": 3247,
	"./frontend/2020.json": 3247,
	"./frontend/2021": 6843,
	"./frontend/2021.json": 6843,
	"./frontend/2022": 7708,
	"./frontend/2022.json": 7708,
	"./frontend/2023": 5403,
	"./frontend/2023.json": 5403,
	"./frontend/2024": 252,
	"./frontend/2024.json": 252,
	"./frontend/2025": 5179,
	"./frontend/2025.json": 5179,
	"./frontend/blog": 2409,
	"./frontend/blog.json": 2409,
	"./frontend/follow": 6573,
	"./frontend/follow.json": 6573,
	"./frontend/images/addy.jpg": 5929,
	"./frontend/images/archibald.jpg": 1826,
	"./frontend/images/frontend-logo.png": 5849,
	"./frontend/images/grigorik.jpg": 6530,
	"./frontend/images/heilmann.jpg": 4338,
	"./frontend/images/irish.jpg": 4725,
	"./frontend/images/js.jpg": 3072,
	"./frontend/images/nicholas.jpg": 311,
	"./frontend/images/souders.jpg": 2199,
	"./frontend/images/sullivan.jpg": 528,
	"./frontend/images/verou.jpg": 2609,
	"./frontend/years": 9196,
	"./frontend/years.json": 9196,
	"./home": 5993,
	"./home.json": 5993,
	"./ios/2017": 670,
	"./ios/2017.json": 670,
	"./ios/2018": 757,
	"./ios/2018.json": 757,
	"./ios/2019": 4378,
	"./ios/2019.json": 4378,
	"./ios/2020": 4060,
	"./ios/2020.json": 4060,
	"./ios/2021": 6947,
	"./ios/2021.json": 6947,
	"./ios/2022": 7655,
	"./ios/2022.json": 7655,
	"./ios/2023": 7753,
	"./ios/2023.json": 7753,
	"./ios/2024": 5594,
	"./ios/2024.json": 5594,
	"./ios/2025": 5023,
	"./ios/2025.json": 5023,
	"./ios/blog": 5481,
	"./ios/blog.json": 5481,
	"./ios/follow": 6026,
	"./ios/follow.json": 6026,
	"./ios/images/AshFurrow.jpg": 9382,
	"./ios/images/ChrisEidhof.jpg": 4755,
	"./ios/images/ChrisLattner.jpg": 4474,
	"./ios/images/DaveVerwer.jpg": 5958,
	"./ios/images/MattGalloway.jpg": 5197,
	"./ios/images/MattGemmell.jpg": 7196,
	"./ios/images/Mattt.jpg": 8671,
	"./ios/images/OleBegemann.jpg": 1829,
	"./ios/images/SimonNg.jpg": 4828,
	"./ios/images/TimCook.jpg": 3194,
	"./ios/images/ios-logo.png": 3633,
	"./ios/images/mac.jpg": 8185,
	"./ios/images/raywenderlich.jpg": 1152,
	"./ios/years": 2666,
	"./ios/years.json": 2666,
	"./iot/2024": 1635,
	"./iot/2024.json": 1635,
	"./iot/2025": 8419,
	"./iot/2025.json": 8419,
	"./iot/blog": 9207,
	"./iot/blog.json": 9207,
	"./iot/follow": 5973,
	"./iot/follow.json": 5973,
	"./iot/images/AlexWilliams.jpg": 7568,
	"./iot/images/PeteWarden.jpg": 1002,
	"./iot/images/StaceyHigginbotham.jpg": 6429,
	"./iot/images/iot.png": 4465,
	"./iot/years": 7023,
	"./iot/years.json": 7023,
	"./marketing/2025": 9624,
	"./marketing/2025.json": 9624,
	"./marketing/blog": 5188,
	"./marketing/blog.json": 5188,
	"./marketing/follow": 4112,
	"./marketing/follow.json": 4112,
	"./marketing/images/sorav-jain-digital-marketing-influencer.png": 2182,
	"./marketing/years": 674,
	"./marketing/years.json": 674,
	"./pm/2023": 9661,
	"./pm/2023.json": 9661,
	"./pm/2024": 2949,
	"./pm/2024.json": 2949,
	"./pm/2025": 633,
	"./pm/2025.json": 633,
	"./pm/blog": 9307,
	"./pm/blog.json": 9307,
	"./pm/follow": 3869,
	"./pm/follow.json": 3869,
	"./pm/images/bandan.jpg": 7943,
	"./pm/images/cagan.jpg": 3993,
	"./pm/images/chris_bakke.jpg": 9880,
	"./pm/images/jen_yang_wong.jpg": 9137,
	"./pm/images/lenny_rachitsky.jpg": 7029,
	"./pm/images/shreyas_doshi.jpg": 7819,
	"./pm/images/toby_rogers.jpg": 3574,
	"./pm/images/trung_phan.jpg": 6974,
	"./pm/product-management-blogs/2023": 719,
	"./pm/product-management-blogs/2023.json": 719,
	"./pm/product-management-blogs/2024": 9855,
	"./pm/product-management-blogs/2024.json": 9855,
	"./pm/product-management-blogs/2025": 5621,
	"./pm/product-management-blogs/2025.json": 5621,
	"./pm/years": 9257,
	"./pm/years.json": 9257,
	"./qa/2017": 1840,
	"./qa/2017.json": 1840,
	"./qa/2018": 4131,
	"./qa/2018.json": 4131,
	"./qa/2019": 3913,
	"./qa/2019.json": 3913,
	"./qa/2020": 251,
	"./qa/2020.json": 251,
	"./qa/2021": 4538,
	"./qa/2021.json": 4538,
	"./qa/2022": 5658,
	"./qa/2022.json": 5658,
	"./qa/2023": 8063,
	"./qa/2023.json": 8063,
	"./qa/2024": 4894,
	"./qa/2024.json": 4894,
	"./qa/2025": 4065,
	"./qa/2025.json": 4065,
	"./qa/blog": 176,
	"./qa/blog.json": 176,
	"./qa/follow": 3859,
	"./qa/follow.json": 3859,
	"./qa/images/AjayBalamurugadas.jpg": 2941,
	"./qa/images/AntonAngelov.jpg": 2853,
	"./qa/images/PeteWalen.jpg": 6666,
	"./qa/images/gary_masnica.jpg": 2659,
	"./qa/images/lisacrispin.jpg": 959,
	"./qa/images/qa-logo.png": 6607,
	"./qa/years": 4742,
	"./qa/years.json": 4742,
	"./quantum-computing/2017": 2392,
	"./quantum-computing/2017.json": 2392,
	"./quantum-computing/2018": 2625,
	"./quantum-computing/2018.json": 2625,
	"./quantum-computing/2019": 6959,
	"./quantum-computing/2019.json": 6959,
	"./quantum-computing/2020": 942,
	"./quantum-computing/2020.json": 942,
	"./quantum-computing/2021": 2072,
	"./quantum-computing/2021.json": 2072,
	"./quantum-computing/2022": 7922,
	"./quantum-computing/2022.json": 7922,
	"./quantum-computing/2023": 3969,
	"./quantum-computing/2023.json": 3969,
	"./quantum-computing/2024": 7875,
	"./quantum-computing/2024.json": 7875,
	"./quantum-computing/2025": 6163,
	"./quantum-computing/2025.json": 6163,
	"./quantum-computing/blog": 1948,
	"./quantum-computing/blog.json": 1948,
	"./quantum-computing/follow": 9769,
	"./quantum-computing/follow.json": 9769,
	"./quantum-computing/images/abraham_asfaw.jpg": 9114,
	"./quantum-computing/images/amira_abbas.jpg": 6727,
	"./quantum-computing/images/anastasia_marchenkova.jpg": 1488,
	"./quantum-computing/images/illyas_khan.jpeg": 6490,
	"./quantum-computing/images/junye_huang.jpg": 2014,
	"./quantum-computing/images/maria_schuld.jpeg": 2692,
	"./quantum-computing/images/olivia_lanes.jpg": 338,
	"./quantum-computing/images/zlatko_minev.jpg": 8265,
	"./quantum-computing/years": 1523,
	"./quantum-computing/years.json": 1523,
	"./robotics-automation/2025": 3818,
	"./robotics-automation/2025.json": 3818,
	"./robotics-automation/blog": 67,
	"./robotics-automation/blog.json": 67,
	"./robotics-automation/follow": 2451,
	"./robotics-automation/follow.json": 2451,
	"./robotics-automation/images/Cynthia.jpg": 7789,
	"./robotics-automation/images/Steve.jpg": 4584,
	"./robotics-automation/images/lex.jpg": 7125,
	"./robotics-automation/years": 7970,
	"./robotics-automation/years.json": 7970,
	"./uiux/2023": 4972,
	"./uiux/2023.json": 4972,
	"./uiux/2024": 1839,
	"./uiux/2024.json": 1839,
	"./uiux/2025": 4983,
	"./uiux/2025.json": 4983,
	"./uiux/blog": 5726,
	"./uiux/blog.json": 5726,
	"./uiux/follow": 992,
	"./uiux/follow.json": 992,
	"./uiux/images/don_norman.jpg": 3919,
	"./uiux/images/farai-madzima.jpg": 3211,
	"./uiux/images/julie_zhuo.jpg": 7630,
	"./uiux/images/luke_wroblewski.jpg": 2270,
	"./uiux/uiuxblogs/2023": 4447,
	"./uiux/uiuxblogs/2023.json": 4447,
	"./uiux/uiuxblogs/2024": 6759,
	"./uiux/uiuxblogs/2024.json": 6759,
	"./uiux/uiuxblogs/2025": 8094,
	"./uiux/uiuxblogs/2025.json": 8094,
	"./uiux/years": 2980,
	"./uiux/years.json": 2980,
	"./web/2017": 6129,
	"./web/2017.json": 6129,
	"./web/2018": 230,
	"./web/2018.json": 230,
	"./web/2019": 8052,
	"./web/2019.json": 8052,
	"./web/2020": 5006,
	"./web/2020.json": 5006,
	"./web/2021": 2964,
	"./web/2021.json": 2964,
	"./web/2022": 4184,
	"./web/2022.json": 4184,
	"./web/blog": 6510,
	"./web/blog.json": 6510,
	"./web/follow": 482,
	"./web/follow.json": 482,
	"./web/images/AndiGutmans.jpg": 5890,
	"./web/images/Anthony.jpg": 5385,
	"./web/images/BradFrost.jpg": 9099,
	"./web/images/DavidWalsh.jpg": 2097,
	"./web/images/DerickRethans.jpg": 2918,
	"./web/images/JordiBoggiano.jpg": 8877,
	"./web/images/JuanTreminio.jpg": 7884,
	"./web/images/LukasKahweSmith.jpg": 3807,
	"./web/images/LukeWroblewski.jpg": 5227,
	"./web/images/RobAllen.jpg": 2239,
	"./web/images/SebastianBergmann.jpg": 7541,
	"./web/images/TaylorOtwell.jpg": 9065,
	"./web/images/web-logo.png": 5192,
	"./web/images/weierophinney.jpg": 4564,
	"./web/years": 4237,
	"./web/years.json": 4237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6482;